'use client';
import React, { useRef, useState } from 'react';
import { ApiAttribute } from '@context/openapi/types';
import InputFieldContainer from '@components/ui/DynamicForm/InputFieldContainer';
import InputLabel from '@components/ui/DynamicForm/InputLabel';
import Dropdown from '@components/ui/DynamicForm/Dropdown';
import InputDescription from '@components/ui/DynamicForm/InputDescription';

interface EnumInputProps {
  field: ApiAttribute;
  onChange: (field: ApiAttribute, value: string) => void;
}

export const EnumInput: React.FC<EnumInputProps> = ({ field, onChange }) => {
  const dropdownRef = useRef<HTMLSelectElement>(null);

  const [_isHelpVisible, setIsHelpVisible] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setTimeout(() => {
      dropdownRef?.current?.showPicker();
    }, 0);
  };

  return (
    <InputFieldContainer field_key={field.key}>
      <div
        className={`flex w-full bg-[#d3e4e6] pl-2 group cursor-pointer`}
        onClick={handleFocus}
      >
        <InputLabel field={field} />
        <div
          className="relative overflow-visible group flex items-center gap-1 flex-1 w-full bg-white"
          data-pendo-mask
        >
          <Dropdown
            ref={dropdownRef}
            isFocused={isFocused}
            setIsFocused={setIsFocused}
            field={field}
            onChange={onChange}
            value={field.value ?? ''}
          />
          <InputDescription
            description={field.description}
            onHelpVisible={(visible) => {
              setIsHelpVisible(visible);
            }}
          />
        </div>
      </div>
    </InputFieldContainer>
  );
};

export default EnumInput;
